import React from 'react';
import UsersIndex from './UsersIndex';

const Users: React.FC = () => {
  return <UsersIndex />;
};

export default Users;


